import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';
import { Helmet } from "react-helmet";

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar.js';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Admin_addteammember(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



   //FILTER VARIABLES

   
  //Variables for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setpageNumber] = useState(1);
     

  //filter_val
  const[filterval,setfilterval]=useState(0);
  const[errorvar,seterrorvar]=useState();

  //Variables
const[data,setData] = useState([]);//SetData Variable


 useEffect(()=>{
   
  getData();
  
  },[])
 





//******************* GET TEAMS DATA FUNCTION START  ********************//
function getData(){

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("get-active-team-list", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,

   //Filters
   'Filter_val' :filterval,
  
   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data);
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
      seterrorvar("Validation error!");

  }

  //Data Violation
  if(response.data.error==102){ 
  

     //Setting Filter Violation Errors
       seterrorvar("Violation Error");


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }

 }
  
 //******************* GET TEAMS DATA FUNCTION END  ********************//


  const[team_id,setteam_id]=useState();const updateteam_id = (event) => { setteam_id(event.target.value);}; const[team_id_er,setteam_id_er]=useState();
  const[username,setusername]=useState();const updateusername = (event) => { setusername(event.target.value);}; const[username_er,setusername_er]=useState();
  const[password,setpassword]=useState();const updatepassword = (event) => { setpassword(event.target.value);}; const[password_er,setpassword_er]=useState();
  const[cpassword,setcpassword]=useState();const updatecpassword = (event) => { setcpassword(event.target.value);}; const[cpassword_er,setcpassword_er]=useState();
  const[member_code,setmember_code]=useState();const updatemember_code = (event) => { setmember_code(event.target.value);}; const[member_code_er,setmember_code_er]=useState();
  const[name,setname]=useState();const updatename = (event) => { setname(event.target.value);}; const[name_er,setname_er]=useState();
  const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
  const[whatsapp,setwhatsapp]=useState();const updatewhatsapp = (event) => { setwhatsapp(event.target.value);}; const[whatsapp_er,setwhatsapp_er]=useState();
  const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
  const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
  const[category,setcategory]=useState();const updatecategory = (event) => { setcategory(event.target.value);}; const[category_er,setcategory_er]=useState();
  const[member_status,setmember_status]=useState();const updatemember_status = (event) => { setmember_status(event.target.value);}; const[member_status_er,setmember_status_er]=useState();

  
 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();


/***************** ADD TEAM MEMBER FUNCTION START  ******************/
function addnewteammember(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){


    //Setting Error Variables
    setteam_id_er(" ");setusername_er(" ");setpassword_er(" ");setcpassword_er(" ");setmember_code_er(" ");setname_er(" ");setcontact_er(" ");
    setwhatsapp_er(" ");setemail_er(" ");settype_er(" ");setcategory_er(" "); setmember_status_er(" "); seterror_msg(" ");
   
    
//Fetching Form Data
let noerror = 0;
let $team_id = document.getElementById("team_id").value; if($team_id==""){ setteam_id_er("Team Id is required !");noerror = noerror+1; }//team_id
let $username = document.getElementById("username").value; if($username==""){ setusername_er("Username is required !");noerror = noerror+1; }//username
let $password = document.getElementById("password").value; if($password==""){ setpassword_er("Password is required !");noerror = noerror+1; }//password
let $cpassword = document.getElementById("cpassword").value; if($cpassword==""){ setcpassword_er("Confirm Password is required !");noerror = noerror+1; }//cpassword
let $member_code = document.getElementById("member_code").value; if($member_code==""){ setmember_code_er("Member Code is required !");noerror = noerror+1; }//member_code
let $name = document.getElementById("name").value; if($name==""){ setname_er("Name is required !");noerror = noerror+1; }//name
let $contact = document.getElementById("contact").value; if($contact==""){ setcontact_er("Contact is required !");noerror = noerror+1; }//contact
let $whatsapp = document.getElementById("whatsapp").value; if($whatsapp==""){ setwhatsapp_er("Whatsapp is required !");noerror = noerror+1; }//whatsapp
let $email = document.getElementById("email").value; if($email==""){ setemail_er("Email is required !");noerror = noerror+1; }//email
let $type = document.getElementById("type").value; if($type==""){ settype_er("Type is required !");noerror = noerror+1; }//type
let $category = document.getElementById("category").value; if($category==""){ setcategory_er("Category is required !");noerror = noerror+1; }//category
let $member_status = document.getElementById("member_status").value; if($member_status==""){ setmember_status_er("Member Status is required !");noerror = noerror+1; }//member_status


//No primary errors
if(noerror==0){

  const addBtn = document.getElementById("submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional


    //disabling button
    document.getElementById('submit-btn').disabled = true; 


  //Sending Data through axios
  axios.post("create-team-member", { 
  Log_id:logid,
  Token:token,
  Team_id:$team_id,
  Username:$username,
  Password:$password,
  Confirm_password:$cpassword,
  Member_code:$member_code,
  Name:$name,
  Contact:$contact,
  Whatsapp:$whatsapp,
  Email:$email,
  Type:$type,
  Category:$category,
  Member_status:$member_status,
  
  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {

     
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "Add New Team Member";

      //enabling button
     // document.getElementById('submit-btn').disabled = false; 

  //Validation Errors
  if(response.data.validatorerror){
  setteam_id_er(response.data.validatorerror.Team_id);
  setusername_er(response.data.validatorerror.Username);
  setpassword_er(response.data.validatorerror.Password);
  setcpassword_er(response.data.validatorerror.Confirm_password);
  setmember_code_er(response.data.validatorerror.Member_code);
  setname_er(response.data.validatorerror.Name);
  setcontact_er(response.data.validatorerror.Contact);
  setwhatsapp_er(response.data.validatorerror.Whatsapp);
  setemail_er(response.data.validatorerror.Email);
  settype_er(response.data.validatorerror.Type);
  setcategory_er(response.data.validatorerror.Category);
  setmember_status_er(response.data.validatorerror.Member_status);
  seterror_msg("Cannot Add Team Member !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

//  settraining_name_er(response.data.validatorerror.Training_name);
  setteam_id_er(response.data.team_id_er);
  setusername_er(response.data.username_er);
  setpassword_er(response.data.password_er);
  setcpassword_er(response.data.cpassword_er);
  setmember_code_er(response.data.member_code_er);
  setname_er(response.data.name_er);
  setcontact_er(response.data.contact_er);
  setwhatsapp_er(response.data.whatsapp_er);
  setemail_er(response.data.email_er);
  settype_er(response.data.type_er);
  setcategory_er(response.data.category_er);
  setmember_status_er(response.data.member_status_er);
  seterror_msg("Cannot Add Team Member !");
  
  
  }
  
  //Invalid Errors
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ 
    
    setteam_id(" ");setusername(" ");setpassword(" ");setcpassword(" ");setmember_code(" ");setname(" ");setcontact(" ");
    setwhatsapp(" ");setemail(" ");settype(" ");setcategory(" "); setmember_status(" "); seterror_msg(" ");
    document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Add Team Member !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** CREATE TRAINING FUNCTION END  ******************/


 
return(
    <>
      <Helmet>
            <meta name="robots" content="noindex,nofollow" />
      </Helmet>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | DOCUMENT MANAGEMENT SYSTEM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

        {/* CREATE SUCCESS CARD START */}
       <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-primary">Team Member Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a><button class="mt-3 btn btn-outline-primary"  onClick={()=>{
                       // sessionStorage.removeItem("EditId");
                        document.getElementById("success-card").style.display="none";
                        
                      }}>Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
       </div>
      {/* CREATE SUCCESS CARD END */}

            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">ADD NEW TEAM MEMBER</p>
                  </a>
                </div>

              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

          
            <div className="row">
              <div className="col-12 grid-margin">
          
            {/* CREATE LICENSE FORM START */}
            <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Add New Team Member</h4>
                    <div class="form-sample">
                      <p class="card-description">add new team member</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Username<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="username" placeholder="Username" value={username} onChange={updateusername} />
                              <code>{username_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Member Code<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="member_code"  placeholder="Member Code" value={member_code} onChange={updatemember_code} />
                              <code>{member_code_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Password<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="password" class="form-control" id="password" placeholder="***********" value={password} onChange={updatepassword} />
                              <code>{password_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Confirm Password<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="cpassword"  placeholder="***********" value={cpassword} onChange={updatecpassword} />
                              <code>{cpassword_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="name" value={name} placeholder="Name" onChange={updatename} />
                              <code>{name_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Member Status<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="member_status" value={member_status} placeholder="1" onChange={updatemember_status} style={{padding:"1rem"}}>
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{member_status_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="type" value={type} placeholder="Type" onChange={updatetype} />
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="category" value={category} placeholder="category" onChange={updatecategory} />
                              <code>{category_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label"> Team<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="team_id" value={team_id} placeholder="" onChange={updateteam_id} style={{padding:"1rem"}}>
                              <option value=" ">select team</option>
                              {
                              data.map((curElm,ind)=>{
                              return(
                              <>         
                              <option value={curElm.Team_id}>{curElm.Team_name}</option>
                              </>
                              )
                              } ) 
                              }
                              </select>
                              <code>{team_id_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="email" value={email} placeholder="myemail@gmail.com" onChange={updateemail} style={{padding:"1rem"}} />
                              <code>{email_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6" id="ifr">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="contact" value={contact} placeholder="918000000000" onChange={updatecontact} />
                              <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6" id="ifr1">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Whatsapp<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="whatsapp" value={whatsapp} placeholder="918000000000" onChange={updatewhatsapp} />
                              <code>{whatsapp_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <button class="btn btn-lg btn-primary" style={{fontWeight:"bold"}} onClick={addnewteammember} id="submit-btn">Add New Team Member</button>
                         </div>
                        </div>
                      
                    </div>
                  </div>
                </div>
            {/* CREATE LICENSE FORM END */}

              </div>
          </div>

            


          {/*}  <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>
          */}
           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Admin_addteammember;